module.exports = "/_next/static/images/12c2371e352a9d79a93d3c141037bd29-roxinho-basicos-flutuantes-md@2x.png";